import React, { Component } from 'react';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import { countries } from '../../../../../common/utils/data';
import { updateInPath } from '../../../../../common/utils';
import { clone } from 'ramda';

class PurchaseOrder extends Component {
  constructor(props) {
    super();

    this.state = {};
  }

  handleChange = (e, {name, value}) => {
    this.setState(s => updateInPath(s, name, value));
  }

  isValidUser = () => {
    return this.state.given_name && this.state.family_name;
  };

  isValidEmail = (data) => {
    return this.state.email && this.state.email.indexOf('@') > -1;
  };

  createPurchaseOrder = () => {
    this.props.onSubmit(clone(this.state));
  };

  render() {
    const { t, data = [] } = this.props;

    return (
      <Form>
        <Header as='h4' content={t('private:po:title')} />
        <Segment content={t('private:po:text1')} />
        <Form.Group widths='equal'>
          <Form.Input
            required
            label={t('private:po.given_name')}
            name='given_name'
            value={data.given_name}
            onChange={this.handleChange}
          />
          <Form.Input
            required
            label={t('private:po.family_name')}
            name='family_name'
            value={data.family_name}
            onChange={this.handleChange}
          />
          <Form.Input
            required
            label={t('private:po.email')}
            name='email'
            value={data.email}
            onChange={this.handleChange}
          />
          <Form.Input
            label={t('private:po.phone')}
            name='phone'
            value={data.phone}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Header as='h5' content={t('private:po:address_details')} />
        <Form.Group>
          <Form.Input
            width={8}
            label={t('private:po.address_1')}
            name='address_2'
            value={data.address_1}
            onChange={this.handleChange}
          />
          <Form.Input
            width={8}
            label={t('private:po.address_2')}
            name='address_2'
            value={data.address_2}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group>
          <Form.Input
            width={4}
            label={t('private:po.city')}
            name='city'
            value={data.city}
            onChange={this.handleChange}
          />
          <Form.Input
            width={4}
            label={t('private:po.state')}
            name='state'
            value={data.state}
            onChange={this.handleChange}
          />
          <Form.Input
            width={3}
            label={t('private:po.zip')}
            name='zip'
            value={data.zip}
            onChange={this.handleChange}
          />
          <Form.Dropdown
            width={5}
            fluid
            search
            selection
            label={t('private:po.country')}
            value={data.country}
            name='country'
            options={countries}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Header as='h5' content={t('private:po:company_details')} />
        <Form.Group>
          <Form.Input
            width={8}
            label={t('private:po.company_name')}
            name='company_name'
            value={data.company_name}
            onChange={this.handleChange}
          />
          <Form.Input
            width={4}
            label={t('private:po.company_code')}
            name='company_code'
            value={data.company_code}
            onChange={this.handleChange}
          />
        </Form.Group>
        {/* TODO: should be save button w/ tooltip */}
        <Button
          positive
          disabled={!this.isValidUser() || !this.isValidEmail()}
          content={t('private:po.create_po')}
          onClick={this.createPurchaseOrder} />
      </Form>
    );
  }
};

export default withNamespaces(['private'])(PurchaseOrder);



// WEBPACK FOOTER //
// ./src/private/user/components/Payment/PurchaseOrder/index.js